// extracted by mini-css-extract-plugin
module.exports = {"table":"non-fuel-business_table__26aUn","subBusinessId":"non-fuel-business_subBusinessId__3BUJt"};